import { render, staticRenderFns } from "./AddPurchaseReturn.vue?vue&type=template&id=4fb40d57&scoped=true&"
import script from "./AddPurchaseReturn.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseReturn.vue?vue&type=script&lang=js&"
import style0 from "./AddPurchaseReturn.vue?vue&type=style&index=0&id=4fb40d57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb40d57",
  null
  
)

export default component.exports